import { useNavigate } from 'react-router-dom';
import { useSearchFields } from '../../SearchFieldProvider';

export default function MobileSearchBar() {
    const navigate = useNavigate();
    const {setShowModal, keyword, categories, location, media, startDate, endDate} = useSearchFields();

    function convertDate(dateString) {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}`;
    }

    let dateRange;

    if (startDate && endDate) {
        dateRange = `${convertDate(startDate)}-${convertDate(endDate)}`
    } else if (startDate && !endDate) {
        dateRange = `${convertDate(startDate)}`
    } else if (!startDate && endDate) {
        dateRange = `${convertDate(endDate)}`
    } else {
        dateRange = '';
    }

    const onSubmit = () => {
        setShowModal(false);
        navigate('/searchResults');
    };

    document.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.keyCode === 13) {
            onSubmit();
        }
    });

    const openModal = () => {
        setShowModal(true);
    }

    const showInKeywordSlot = keyword ? keyword : (!keyword && categories[0]) ? categories[0].label : (!keyword && media[0]) ? media[0].label : (!keyword && location) ? location : keyword;

    return (
        <div className="row justify-content-around search-bar mx-auto search-outline w-100 gx-2"> 
                <div className="col-10 col-lg-auto me-auto">
                    <div className="input-group input-group-lg">
                        <input type="text" className="form-control" placeholder="Keyword" aria-label="Keyword" onFocus={openModal} readOnly={true}
                            style={{ borderTopLeftRadius: 500, borderBottomLeftRadius: 500, fontSize: 16, color: "gray"}} value={showInKeywordSlot}/>
                        <input id="endDate" className="form-control" type="text" placeholder="Date range" onFocus={openModal} readOnly={true}
                            style={{ borderTopRightRadius: 500, borderBottomRightRadius: 500, fontSize: 16, color: "gray"}} value={dateRange}/>
                    </div>
                </div>
                <div className="col-2 col-lg-auto">
                    <button className="btn btn-lg btn-dark" type="submit" onClick={onSubmit}
                    style={{ borderRadius: 500 }}>
                            <i className="fa fa-search"></i>
                    </button>
                </div>
            </div>


    );
}
